var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "element-2 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.26988 22.75H4.22988C2.21988 22.75 1.24988 21.82 1.24988 19.9V4.1C1.24988 2.18 2.22988 1.25 4.22988 1.25H8.26988C10.2799 1.25 11.2499 2.18 11.2499 4.1V19.9C11.2499 21.82 10.2699 22.75 8.26988 22.75ZM4.22988 2.75C2.95988 2.75 2.74988 3.09 2.74988 4.1V19.9C2.74988 20.91 2.95988 21.25 4.22988 21.25H8.26988C9.53988 21.25 9.74988 20.91 9.74988 19.9V4.1C9.74988 3.09 9.53988 2.75 8.26988 2.75H4.22988Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.7699 13.75H15.7299C13.7199 13.75 12.7499 12.82 12.7499 10.9V4.1C12.7499 2.18 13.7299 1.25 15.7299 1.25H19.7699C21.7799 1.25 22.7499 2.18 22.7499 4.1V10.9C22.7499 12.82 21.7699 13.75 19.7699 13.75ZM15.7299 2.75C14.4599 2.75 14.2499 3.09 14.2499 4.1V10.9C14.2499 11.91 14.4599 12.25 15.7299 12.25H19.7699C21.0399 12.25 21.2499 11.91 21.2499 10.9V4.1C21.2499 3.09 21.0399 2.75 19.7699 2.75H15.7299Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.7699 22.75H15.7299C13.7199 22.75 12.7499 21.82 12.7499 19.9V18.1C12.7499 16.18 13.7299 15.25 15.7299 15.25H19.7699C21.7799 15.25 22.7499 16.18 22.7499 18.1V19.9C22.7499 21.82 21.7699 22.75 19.7699 22.75ZM15.7299 16.75C14.4599 16.75 14.2499 17.09 14.2499 18.1V19.9C14.2499 20.91 14.4599 21.25 15.7299 21.25H19.7699C21.0399 21.25 21.2499 20.91 21.2499 19.9V18.1C21.2499 17.09 21.0399 16.75 19.7699 16.75H15.7299Z",
    fill: "#1F1F1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.f72c5e3c8aa8a42e06a561ce83085d3d.svg";
export { ForwardRef as ReactComponent };